/* eslint-disable */
require('./aboutus')
require('./account')
require('./accountsettings')
require('./activity')
require('./api')
require('./archive')
require('./attatchments')
require('./calendar')
require('./category')
require('./closemodal')
require('./commission')
require('./copy')
require('./custompage')
require('./dashboard')
require('./delete')
require('./doc')
require('./download')
require('./echob2b_logo')
require('./evaluation')
require('./exam')
require('./files')
require('./Folder')
require('./globe')
require('./grflag')
require('./history')
require('./iconadd')
require('./invoices-outstanding')
require('./invoices-overdue')
require('./invoices')
require('./kb')
require('./links')
require('./logo-echo')
require('./logout')
require('./materials')
require('./menu')
require('./messages')
require('./notes')
require('./open_book')
require('./orders-icon')
require('./orders')
require('./pclients')
require('./pdf')
require('./picture')
require('./portal')
require('./posts')
require('./preview')
require('./profilency_configuration')
require('./profilency_dashboard')
require('./profilency_meetings')
require('./profilency_products')
require('./profilency_profilings')
require('./profilency_statistics')
require('./profilencylogo')
require('./profilesettings')
require('./projects')
require('./projectsoverview')
require('./renew')
require('./stock')
require('./subscriptions')
require('./tasks_filled')
require('./tasks-icon')
require('./tasks')
require('./terms')
require('./tickets')
require('./training')
require('./transaction')
require('./trash')
require('./ukflag')
require('./users')
require('./video_invert')
require('./video')
require('./xls')



// WEBPACK FOOTER //
// ./src/compiled-icons/index.js